/* eslint new-cap: "off" */
define([
	'components/toggleLink/toggleLink',
	'components/utilities/utilities',
	'components/dropdown/dropdown',
	'components/autoSubmit/autoSubmit',
	'components/checkboxRequiredGroup/checkboxRequiredGroup',
	'components/jumptotop/jumptotop',
	'components/acceptCookies/acceptCookies',
	'libs/nanoajax',
	'libs/auto-complete',
	'components/loader/loader'
], function (toggleLink, utils, dropdown, autoSubmit, checkboxRequiredGroup, jumptotop, acceptCookies, nanoajax, autoComplete) {
	'use strict';

	/**
	 * App
	 * This is the initialization file for all scripts.
	 * @version 1.0.7
	 * @see {@link http://youmightnotneedjquery.com/}
	 * @exports app
	 */
	var app = {

		/**
		 * The initialization function for this module.
		 * @public
		 */
		init: function () {
			console.log("HEJ");

			// Initiates the requestanimationframe polyfill
			utils.RAFPolyfill();

			// Initiates the DOMParser polyfill
			utils.DOMParserPolyfill();

			// Init toggle content
			toggleLink.init();

			// Init dropdown
			dropdown.init();

			// Init autosubmit
			autoSubmit.init();

			// Init checkboxRequiredGroup
			checkboxRequiredGroup.init();

			// Init Jump to top
			jumptotop.init();

			// Init accept cookies
			acceptCookies.init();

			// Init enter-press handle for checkboxes/radios
			this._initCheckboxRadioEnterPress();

			// Init autosize
			this._initAutoSize();

			// Init Back-link
			this._initBacklink();

			// Init Kolada integration
			//this._initKoladaIntegration();

			// Init Readspeaker integration
			this._initReadspeaker();

			// Init Vergic integration
			//this._initVergic();

			// Init Gismo (map) integration
			//this._initMap();

			// Init IsyMap integration
			//this._initIsyMap();

			// Init Leave site button
			//this._initLeaveSiteButton();

			// Init datepicker
			this._initDatepicker();

			// Init loadContent
			this._initLoadContent();

			// Init trigger
			this._initTrigger();

			// Init loadMore
			this._initLoadMore();

			// Init ajaxForm
			this._initAjaxForm();

			// Init episerverForm
			this._initEpiserverForm();

			// Init search tracking
			this._initSearchTracking();

			// Init compareList
			//this._initCompareList();

			// Init compareTable
			//this._initCompareTable();

			// Init anchorScroll
			this._initAnchorScroll();

			// Init rte table wrapp
			this._initRteTableWrap();

			// Init autocomplete
			this._initAutocomplete();

			// Init browser bug fixes
			this._browserBugFixes();

			// If pinboard mode (Anslagstavla), load some extras.
			//this._initPinboardMode();


			// this._initYoutube();
		},

		// _initYoutube: function() {
		// 	var iframes = document.querySelectorAll('.responsive-iframe iframe');

		// 	var tag = document.createElement('script');

		// 	tag.src = "https://www.youtube.com/iframe_api";
		// 	var firstScriptTag = document.getElementsByTagName('script')[0];
		// 	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

		// 	if (iframes.length > 0) {
		// 		var player;
		// 		window.onYouTubeIframeAPIReady = function () {
		// 			console.log('here');
					
		// 			utils.forEach(iframes, function (iframe) {
		// 				player = new YT.Player(iframe.getAttribute('id'), {
		// 					events: {
		// 						onStateChange: onPlayerStateChange
		// 					}
		// 				});
		// 			});
		// 		};

		// 		var onPlayerStateChange = function (event) {
		// 			if (event.data == 0) //video ended
		// 				player.stopVideo();
		// 		};
	
		// 	}
		// },


		/**
		 * Function that initiates autosizing on textareas.
		 * @private
		 */
		_initAutoSize: function () {
			var textareas = document.querySelectorAll('textarea');

			if (textareas.length > 0) {
				require(['libs/autosize'], function (autosize) {
					autosize(textareas);
				});
			}
		},


		/**
		 * Select the focused checkbox/radio with enter-press (instead of submitting the form).
		 * @private
		 */
		_initCheckboxRadioEnterPress: function () {
			// Checkboxes
			utils.forEachElement('input[type="checkbox"]', this._checkboxRadioEnterPressAddEvent);

			// Radio buttons
			utils.forEachElement('input[type="radio"]', this._checkboxRadioEnterPressAddEvent);
		},


		/**
		 * Adds a keydown event to prevent submitting the form on enter-press.
		 * @param {Object} el - A DOM node.
		 * @see {@link module:app._initCheckboxRadioEnterPress}
		 * @private
		 */
		_checkboxRadioEnterPressAddEvent: function (el) {
			utils.addEventListener(el, 'keydown', function (event) {
				var charCode = (typeof event.which === 'number') ? event.which : event.keyCode;

				if (charCode === 13) {
					if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }

					if (el.getAttribute('type') === 'radio') {
						el.checked = true;
					} else {
						el.checked = !el.checked; // Toggle checked
					}
				}
			});
		},


		/**
		 * Function that wraps all tables in rte with a div to enable the scroll-feature in mobile.
		 * @private
		 */
		_initRteTableWrap: function () {
			utils.forEachElement('.t-rte table', function (el) {
				var wrapper = document.createElement('div');
				utils.addClass(wrapper, 'table-scrollable');
				utils.wrap(el, wrapper);
			});
		},


		/**
		 * Function that initiates the Back link functionality.
		 * @private
		 */
		_initBacklink: function () {
			utils.forEachElement('[data-type="backlink"]', function (el) {
				utils.addEventListener(el, 'click', function (event) {
					if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }
					window.history.back();
				});
			});
		},


		/**
		 * Function that initiates the Kolada integration.
		 * @private
		 */
		_initKoladaIntegration: function () {
			var koladaNode = document.getElementById('KoladaVisualizerPlaceHolder');

			if (koladaNode !== null) {
				require(['components/kolada/kolada'], function (koladaIntegration) {
					koladaIntegration.init(koladaNode);
				});
			}
		},


		/**
		 * Function that initiates the "Leave site" functionality.
		 * @private
		 */
		_initLeaveSiteButton: function () {
			var leaveSiteButtonNode = document.getElementById('leave-site-button');

			if (leaveSiteButtonNode !== null) {
				require(['components/leaveSiteButton/leaveSiteButton'], function (leaveSiteButton) {
					leaveSiteButton.init(leaveSiteButtonNode);
				});
			}
		},


		/**
		 * Function that initiates the "Readspeaker" integration.
		 * @private
		 */
		_initReadspeaker: function () {
			var readspeakerLink = document.getElementById('readspeaker-link');

			if (readspeakerLink !== null) {
				require(['components/readspeaker/readspeaker'], function (readspeaker) {
					readspeaker.init(readspeakerLink);
				});
			}
		},


		/**
		 * Function that initiates the "Vergic" (chat) integration.
		 * @private
		 */
		_initVergic: function () {
			if (mainConfig.vergic !== undefined && mainConfig.vergic.enabled === true && mainConfig.vergic.url !== undefined && mainConfig.vergic.guid !== undefined) {
				var s = document.createElement('script');
				s.type = 'text/javascript';
				s.src = mainConfig.vergic.url + '/' + mainConfig.vergic.guid + '/ps.js';
				document.getElementsByTagName('head')[0].appendChild(s);
			}
		},


		/**
		 * Function that initiates the "Gismo" (map) integration.
		 * @private
		 */
		_initMap: function () {
			var mapNode = document.getElementById('gismoMap');

			if (mapNode !== null) {
				require(['components/map/map'], function (map) {
					map.init(mapNode);
				});
			}
		},


		/**
		 * Function that initiates the "Gismo" (map) integration.
		 * @private
		 */
		_initIsyMap: function () {
			var mapNode = document.querySelector('[data-type="isymap"]');

			if (mapNode !== null) {
				var scriptTag = document.createElement('script');
				scriptTag.setAttribute('src', 'https://karta.huddinge.se/PublikKommunkarta/isymap.js?callback=initMap');
				scriptTag.setAttribute('type', 'text/javascript');
				scriptTag.setAttribute('rel', 'preload');
				document.head.appendChild(scriptTag);

				require(['components/isymap/isymap'], function (map) {
					map.init(mapNode);
				});
			}
		},


		/**
		 * Function that initiates the datepicker.
		 * @private
		 */
		_initDatepicker: function () {
			var dateInputs = document.querySelectorAll('[data-type="datepicker"]');

			if (dateInputs.length > 0) {
				require(['components/datepicker/datepicker'], function (datepicker) {
					datepicker.init(dateInputs);
				});
			}
		},


		/**
		 * Function that initiates the load more functionality.
		 * @private
		 */
		_initLoadMore: function () {
			var el = document.querySelector('[data-type="loadMore"]');

			if (el !== null) {
				require(['components/loadMore/loadMore'], function (loadMore) {
					loadMore.init(el);
				});
			}
		},


		/**
		 * Function that initiates the ajax-form functionality.
		 * @private
		 */
		_initAjaxForm: function () {
			var els = document.querySelectorAll('[data-type="ajaxForm"]');

			if (els.length > 0) {
				require(['components/ajaxForm/ajaxForm'], function (AjaxForm) {
					for (var i = 0; i < els.length; i++) {
						var el = els[i],
							ajaxForm = new AjaxForm();

						if (el.getAttribute('data-ajaxform-initiated') === null) {
							ajaxForm.init(el);
							el.setAttribute('data-ajaxform-initiated', true);
						}
					}
				});
			}
		},


		/**
		 * Function that initiates the episerver form functionality.
		 * @private
		 */
		_initEpiserverForm: function () {
			var els = document.querySelectorAll('[data-type="episerverForm"]');

			if (els.length > 0) {
				require(['components/episerverForm/episerverForm'], function (EpiserverForm) {
					for (var i = 0; i < els.length; i++) {
						var el = els[i],
							episerverForm = new EpiserverForm();

						if (el.getAttribute('data-episerverform-initiated') === null) {
							episerverForm.init(el);
							el.setAttribute('data-episerverform-initiated', true);
						}
					}
				});
			}
		},


		/**
		 * Function that initiates the search tracking.
		 * @private
		 */
		_initSearchTracking: function () {
			var el = document.getElementById('search-list');

			if (el !== null) {
				require(['components/searchTracking/searchTracking'], function (searchTracking) {
					searchTracking.init();
				});
			}
		},


		/**
		 * Function that initiates the loadcontent plugin.
		 * @private
		 */
		_initLoadContent: function () {
			var els = document.querySelectorAll('[data-type="loadContent"]');

			if (els.length > 0) {
				require(['components/loadContent/loadContent'], function (loadContent) {
					loadContent.init(els);
				});
			}
		},


		/**
		 * Function that initiates the link-trigger functionality.
		 * This can be used to have on link to trigger a click on another.
		 * @private
		 */
		_initTrigger: function () {
			utils.addEventListener(document, 'click', function (event) {
				if (event.target.getAttribute('data-type') === 'trigger') {
					if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }

					var target = document.getElementById(event.target.getAttribute('data-target'));

					if (target.click) {
						target.click();
					} else {
						var clickEvent = document.createEvent('HTMLEvents');
						clickEvent.initEvent('click', true, true);
						target.dispatchEvent(clickEvent);
					}
				}
			});
		},


		_initAutocomplete: function () {
			new autoComplete({
				selector: 'input[name="q"]',
				source: function (term, response) {
					term = encodeURIComponent(term);
					var url = mainConfig.autocompleteUrl.indexOf('?') !== -1 ? mainConfig.autocompleteUrl + '&q=' + term : mainConfig.autocompleteUrl + '?q=' + term;
					nanoajax.ajax({
						method: 'GET',
						headers: {
							'X-Requested-With': 'XMLHttpRequest'
						},
						url: url
					},
					function (code, responseText) {
						var data = false,
							suggestions = [];

						if (code === 200) {
							try {
								data = JSON.parse(responseText);
							} catch (e) {}

							if (data) {
								for (var i = 0; i < data.suggestions.length; i++) {
									suggestions.push(data.suggestions[i].label);
								}
							}
						}
						response(suggestions);
					});
				}
			});
		},


		/**
		 * Function that initiates the ajax-form functionality.
		 * @private
		 */
		_initCompareList: function () {
			var el = document.querySelector('[data-type="compareList"]');

			if (el !== null) {
				require(['components/compareList/compareList'], function (compareList) {
					compareList.init(el);
				});
			}
		},


		/**
		 * Function that initiates the compare-table functionality.
		 * @private
		 */
		_initCompareTable: function () {
			var el = document.querySelector('[data-type="compareTable"]');

			if (el !== null) {
				require(['components/compareTable/compareTable'], function (compareTable) {
					compareTable.init(el);
				});
			}
		},


		/**
		 * Function that initiates the compare-table functionality.
		 * @private
		 */
		_initAnchorScroll: function () {
			var els = document.querySelectorAll('[data-type="anchorScroll"]');

			if (els.length > 0) {
				require(['components/anchorScroll/anchorScroll'], function (anchorScroll) {
					anchorScroll.init(els);
				});
			}
		},


		/**
		 * Add some fixes for some specific browsers.
		 * @private
		 */
		_browserBugFixes: function () {
			var ua = navigator.userAgent.toLowerCase();

			if (ua.indexOf('android 4.') > -1) {
				utils.addClass(document.body, 'is-android-4');
			}
		}
	};


	return app;
});



//////////////////
// WEBPACK FOOTER
// ./app.js
// module id = 1
// module chunks = 0